import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  slideOneForm: FormGroup;
  slideOneFormLogin: FormGroup;
  slideOneFormRecuperar: FormGroup;
  modalRef: BsModalRef;
  jsonArrayEstados: any;
  jsonArrayCidades: any;
  jsonArray: any;
  jsonValidar: any;
  jsonEmail: any;

  config = {
    keyboard: false,
    backdrop: false,
    ignoreBackdropClick: true
  };

  constructor(private modalService: BsModalService, public formBuilder: FormBuilder, private apiService: ApiService,
    private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.slideOneForm = this.formBuilder.group({
      empresa: ['', Validators.required],
      segmento: ['', Validators.required],
      estado: ['SP'],
      cidade: ['INDAIATUBA'],
      site: ['', Validators.required],
      cnpj: ['', Validators.required],
      nota: ['5'],
      responsavel: [''],
      password: ['', Validators.required]
    });

    this.slideOneFormLogin = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    this.slideOneFormRecuperar = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.carregarEstados();
  }

  carregarEstados() {
    this.apiService.getEstados()
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayEstados = data;

          this.carregarCidades();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarCidades() {
    this.apiService.getCidades()
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayCidades = data;

          this.carregarSegmento();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  carregarSegmento() {
    this.apiService.getListagem('segmentos')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  cadastroEmpresa(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  modalEntrar(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  salvarDados() {
    this.jsonValidar = [];
    if (this.slideOneForm.invalid) {
      this.toastr.warning('VERIFIQUE OS CAMPOS OBRIGATÓRIOS!', 'Atenção!');
    } else {

      if (this.validarCNPJ()) {
        this.spinner.show()
        this.apiService.getListagemId('lojistascadastro', this.slideOneForm.get('empresa').value)
          .subscribe(
            (data) => { //start of (1)

              this.jsonValidar = data;

              if (this.jsonValidar.length === 0) {
                this.salvarCadastro();
              } else {
                this.spinner.hide();
                this.toastr.warning('A empresa informada já possui cadastro!', 'Atenção!');
              }

            }, //end of (1)
            (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
            () => console.log('all data gets') //(3) second argument
          );
      } else {
        this.toastr.warning('CNPJ INFORMADO NÃO É VÁLIDO!', 'Atenção!');
      }
    }
  }

  validarCNPJ() {
    var cnpj = this.slideOneForm.get('cnpj').value;
    cnpj = cnpj.replace(/[^\d]+/g, '');
    var valida = new Array(6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2);
    var dig1 = 0;
    var dig2 = 0;
    let exp = /\.|\-|\//g;
    cnpj = cnpj.toString().replace(exp, "");
    if (cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" ||
      cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" ||
      cnpj == "88888888888888" || cnpj == "99999999999999") {
      return false;
    } else {
      var digito = new Number(eval(cnpj.charAt(12) + cnpj.charAt(13)));

      for (var i = 0; i < valida.length; i++) {
        dig1 += (i > 0 ? (cnpj.charAt(i - 1) * valida[i]) : 0);
        dig2 += cnpj.charAt(i) * valida[i];
      }

      dig1 = (((dig1 % 11) < 2) ? 0 : (11 - (dig1 % 11)));
      dig2 = (((dig2 % 11) < 2) ? 0 : (11 - (dig2 % 11)));

      if (((dig1 * 10) + dig2) != digito) {
        return false;
      } else {
        return true;
      }
    }
  }

  salvarCadastro() {
    this.apiService.saveCadastro('salvarlojistacheckout', this.slideOneForm.value)
      .subscribe(
        (data) => { //start of (1)

          if (data) {
            localStorage.setItem('acesso', 'true');
            localStorage.setItem('lojistaid', data.toString());
            this.spinner.hide();
            this.router.navigate(['/entrar'], { replaceUrl: true });
          } else {
            localStorage.setItem('acesso', 'false');
            localStorage.setItem('lojistaid', 'null');
            this.spinner.hide();
            this.toastr.warning('HOUVE UM ERRO AO VALIDAR OS DADOS, TENTE NOVAMENTE!', 'Atenção!');
          }

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  autenticarUser() {
    var email = this.slideOneFormLogin.get('email').value;
    var senha = this.slideOneFormLogin.get('password').value;

    this.spinner.show();
    this.apiService.autenticarApp('autenticarapp', email, senha)
      .subscribe(
        (data) => { //start of (1)

          this.jsonArray = data;

          this.spinner.hide();

          if (this.jsonArray.length === 1) {
            localStorage.setItem('acesso', 'true');
            localStorage.setItem('lojistaid', this.jsonArray[0].lojistaid);
            this.modalRef.hide();
            this.router.navigate(['/entrar'], { replaceUrl: true });
          } else {
            localStorage.setItem('acesso', 'false');
            localStorage.setItem('lojistaid', 'null');
            this.toastr.warning('Usuário ou senha incorretos!', 'Atenção!');
          }

        }, //end of (1)
        (error: any) => {
          this.spinner.hide();
          localStorage.setItem('acesso', 'false');
          localStorage.setItem('lojistaid', 'null');
          this.toastr.warning('Usuário ou senha incorretos!', 'Atenção!');
          console.log("ERROR: " + JSON.parse(JSON.stringify(error)));
        }, //(2) second argument
        () => console.log('all data gets') //(3) second argument
      )
  }

  recuperarSenha(template) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  recuperar() {
    this.jsonEmail = [];
    if (this.slideOneFormRecuperar.valid) {
      this.spinner.show()
      this.apiService.getListagemId('verificaremail', this.slideOneFormRecuperar.get('email').value)
        .subscribe(
          (data) => { //start of (1)

            this.jsonEmail = data;

            if (this.jsonEmail.length === 0) {
              this.spinner.hide();
              this.toastr.warning('E-mail inválido, informe seu e-mail de cadastro!', 'Atenção!');
            } else {
              this.enviarEmailRecuperacao();
            }

          }, //end of (1)
          (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
          () => console.log('all data gets') //(3) second argument
        );
    } else {
      this.toastr.warning('E-mail inválido, informe seu e-mail de cadastro!', 'Atenção!');
    }
  }

  enviarEmailRecuperacao() {
    this.apiService.getEnviarEmail('enviaremailrecuperacao', this.slideOneFormRecuperar.get('email').value, this.jsonEmail[0].lojistaid)
      .subscribe(
        (data) => { //start of (1)

          this.spinner.hide();
          this.toastr.success('Enviamos um e-mail para redefinir sua senha!', 'Sucesso!');
          this.modalRef.hide()

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

}
